import { useState } from "react";

function AddProject({ onProjectAdded }) {
  const [formData, setFormData] = useState({
    project_title: "",
    client: "",
    start_date: "",
    project_overview: "",
    scope_of_work: "",
    technical_requirements: "",
    deliverables: "",
    eta: "",
    changes: "",
    acceptance_criteria: "",
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    try {
      const response = await fetch("http://localhost:5002/admin/addproject", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(formData),
      });

      if (!response.ok) {
        throw new Error("Failed to add project");
      }

      alert("Project added successfully!");
      setFormData({
        project_title: "",
        client: "",
        start_date: "",
        project_overview: "",
        scope_of_work: "",
        technical_requirements: "",
        deliverables: "",
        eta: "",
        changes: "",
        acceptance_criteria: "",
      });

      onProjectAdded();
    } catch (error) {
      console.error("Error adding project:", error);
      alert("Error adding project!");
    }
  };

  return (
    <form onSubmit={handleSubmit} style={{ display: "flex", flexDirection: "column", gap: "10px", maxWidth: "500px", margin: "auto" }}>
      <label htmlFor="project_title"><strong>Project Title:</strong></label>
      <input id="project_title" type="text" name="project_title" value={formData.project_title} onChange={handleChange} required />

      <label htmlFor="client"><strong>Client:</strong></label>
      <input id="client" type="text" name="client" value={formData.client} onChange={handleChange} required />

      <label htmlFor="start_date"><strong>Start Date:</strong></label>
      <input id="start_date" type="date" name="start_date" value={formData.start_date} onChange={handleChange} required />

      <label htmlFor="project_overview"><strong>Project Overview:</strong></label>
      <textarea id="project_overview" name="project_overview" value={formData.project_overview} onChange={handleChange}></textarea>

      <label htmlFor="scope_of_work"><strong>Scope of Work:</strong></label>
      <textarea id="scope_of_work" name="scope_of_work" value={formData.scope_of_work} onChange={handleChange}></textarea>

      <label htmlFor="technical_requirements"><strong>Technical Requirements:</strong></label>
      <textarea id="technical_requirements" name="technical_requirements" value={formData.technical_requirements} onChange={handleChange}></textarea>

      <label htmlFor="deliverables"><strong>Deliverables:</strong></label>
      <textarea id="deliverables" name="deliverables" value={formData.deliverables} onChange={handleChange}></textarea>

      <label htmlFor="eta"><strong>ETA:</strong></label>
      <input id="eta" type="date" name="eta" value={formData.eta} onChange={handleChange} />

      <label htmlFor="changes"><strong>Changes:</strong></label>
      <textarea id="changes" name="changes" value={formData.changes} onChange={handleChange}></textarea>

      <label htmlFor="acceptance_criteria"><strong>Acceptance Criteria:</strong></label>
      <textarea id="acceptance_criteria" name="acceptance_criteria" value={formData.acceptance_criteria} onChange={handleChange}></textarea>

      <button type="submit">Add Project</button>
    </form>
  );
}

export default AddProject;
